import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { CallService } from '../services/call.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserModel } from 'src/app/store/storeModels/user.model';
import { AppState } from 'src/app/store/app.state';
import { Store } from "@ngrx/store";


@Component({
  selector: 'app-calls-lookup',
  templateUrl: './calls-lookup.component.html',
  styleUrls: ['./calls-lookup.component.css']
})
export class CallsLookupComponent implements OnInit {

  dataTable = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
      { title: "Ticket Source", key: "source" },
      { title: "Ticket Subject", key: "subject" },
      { title: "Due Date", key: "dueDate" },
      { title: "Ticket Status", key: "status" },
      { title: "Ticket Priority", key: "priority" },
      { title: "Action", key: "action" },

    ],
    options: {
      datePipe: {},
      singleActions: [
        {
          title: "View Ticket",
          showIf: () => this.generalSrv.isAuthorized("VIEW_ALL_TICKET"),
        }
      ],
      bulkActions: [],
    },
  }

  origin = window.location.origin
  clientInfo: { clientType: string; clientInfo: any; };
  clientType: string;
  arrayTickets: any;
  clientId: any;
  orgId: any;
  id: any;
  private user: UserModel;

  
  

  constructor( 
    private callSrv: CallService,
    private generalSrv: GeneralService,
    private router: Router,
    route: ActivatedRoute,
    store: Store<AppState>
  ) { 
    route.params.subscribe(res => {
      this.orgId = res.orgId
      this.id = res.id
    })
    store.select("userInfo").subscribe((info) => {
      this.user = info.user;
    });
  }


  ngOnInit() {
    this.checkResult();
    this.getTicketsByClientId();
  }


  get_client_info() {
    const query = `id=${this.id}`
    const orgId = this.orgId
    return forkJoin(this.getCompany(query, orgId), this.getContact(query, orgId))
      .pipe(map(([companyRes, contactRes]) => {
        if(companyRes || contactRes) {
          const company = companyRes && companyRes.success ? companyRes.payload.records[0] : null;
          const contact = contactRes && contactRes.success ? contactRes.payload.records[0] : null;
          const clientType = company ? "company" : "contact";
          const clientInfo = company || contact 
          return { clientType, clientInfo };
        } else {
          return null
        }
        })
      )
  }

  dataFeedBackObsListener = (data) => {
    switch (data.type) {
      case "singleaction":
        if (data.action === "View Ticket") {
          if (this.generalSrv.isAuthorized("VIEW_ALL_TICKET")) {
              this.router.navigate(["/ticket/ticket-view/" + data.data.code]);
            } 
          }  
        break;

      default:
        break;
    }
  }

   checkResult(){
    this.get_client_info().subscribe(res => {
      this.clientInfo = res.clientInfo
      this.clientType = res.clientType;
    })
  }

  async getTicketsByClientId() {
    try {
    this.get_client_info().subscribe(res => {
      this.clientId = res.clientInfo.clientId
      this.orgId = res.clientInfo.orgId

      let payload = {
        id: this.clientId.toString(),
        startDate: 1579091167195,
        endDate: new Date().getTime(),
      };

      this.callSrv.getTicketsByClientId(payload, this.orgId).subscribe((res: any) => {
        this.arrayTickets = res.map(ticket => ({ ...ticket, dueDate: new Date(ticket.dueDate).toLocaleDateString()}));
        this.dataTable.dataChangedObs.next(true);
          
      })});

    }catch (error) {
      console.log('error', error)
    } finally {

    }
  }

  addTicket(clientInfo){
    const queryParams = this.query(clientInfo);
    this.router.navigate([`/ticket/all-ticket`], {queryParams}); 
  }

  query(data) {
    const { firstName, email, clientId, otherName, name } = data;
    const clientName = firstName ? firstName : name
    return {
      action: 'create-ticket',
      clientId: clientId ? clientId : 0,
      clientName: clientId ? clientName : email,
      clientEmail: clientId ? email : '',
      agentID: this.user? `${this.user.id}`: '',
      agentName: this.user? `${this.user.firstName} ${this.user.lastName}`: ''
    }
  }

  getCompany(query, orgId) {
    return this.callSrv.getCompaniesByFilter(query, orgId);
  }
  getContact(query, orgId) {
    return this.callSrv.getContactsByFilter(query, orgId);
  }

}
